export default __webpack_public_path__ + "static/media/telegram.aae7141f.png";